module.exports = __webpack_public_path__ + "img/icon_addphoen.5c98a56d.jpg";